import { Box, Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import {
  lighten,
  makeStyles,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import React, { FC, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import zxcvbn from "zxcvbn";

interface StylesProps {
  color: string;
}
const BorderLinearProgress = withStyles({
  root: {
    height: 10,
    backgroundColor: lighten("#F5F6FA", 0.5),
    maxWidth: 450,
  },
  bar: {
    borderRadius: 20,
  },
})(LinearProgress);
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    "@media (max-width:820px)": {
      marginRight: 16,
    },
  },
  margin: {
    margin: theme.spacing(1, 0),
  },
  barColor: (props: StylesProps) => ({
    backgroundColor: props.color,
  }),
}));

const getInfo = (label: string) => {
  switch (label) {
    case "Fair":
      return { color: "#ff9800", intl: "pwd.fair" }; // orange
    case "Good":
      return { color: "#ffef62", intl: "pwd.good" }; // yellow
    case "Strong":
      return { color: "#4caf50", intl: "pwd.strong" }; // green
    default:
      return { color: "#ff6c5c", intl: "pwd.weak" }; // red
  }
};

interface PasswordMeterProps {
  password: string;
}
const PasswordMeter: FC<PasswordMeterProps> = (props) => {
  const { password } = props;
  const [label, setLabel] = useState("Weak");
  const { color, intl } = getInfo(label);
  const classes = useStyles({ color });
  const { score } = zxcvbn(password);
  const completed = 25 * score;
  useEffect(() => {
    switch (score) {
      case 2:
        setLabel("Fair");
        break;
      case 3:
        setLabel("Good");
        break;
      case 4:
        setLabel("Strong");
        break;
      default:
        setLabel("Weak");
        break;
    }
  }, [password]);
  return (
    <Box>
      <BorderLinearProgress
        className={classes.margin}
        variant="determinate"
        color="secondary"
        value={completed}
        classes={{
          bar: classes.barColor,
        }}
      />
      <Typography variant={"subtitle1"} display={"inline"}>
        <FormattedMessage id="pwd.meter" />
      </Typography>
      <Typography display={"inline"}>
        &nbsp;
        <FormattedMessage id={intl} />
      </Typography>
    </Box>
  );
};
export default PasswordMeter;
